module.exports = "<svg class=\"sv-svg-icon\"><use></use></svg>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/components/svg-icon/svg-icon.html
// module id = 118
// module chunks = 0